import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M9.375 14.813V9.232L15 6.419V12zM3 6.419l5.625 2.813v5.58L3 12zM9 3l5.58 2.79L9 8.58 3.42 5.79zm6.335 2.329-6-3a.75.75 0 0 0-.67 0l-6 3A.75.75 0 0 0 2.25 6v6c0 .284.16.544.415.671l6 3a.75.75 0 0 0 .67 0l6-3A.75.75 0 0 0 15.75 12V6a.75.75 0 0 0-.415-.671",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }